var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('div',{staticClass:"auth-screen"},[_c('v-overlay',{attrs:{"z-index":"0"}}),_c('amplify-authenticator')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }